import React, { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import EditPackage from './EditPackage'
import { Link, useLocation } from 'react-router-dom'

const PackageDetailes = ({ pack }) => {
  console.log(pack)

  const [paclageDetails, setPackageDetails] = useState(pack)
  const [edit, setEdit] = useState(false)
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const cardNmae = query.get('card_name')

  const updatePackage = (newPackage) => {
    setPackageDetails(newPackage)
  }

  return (
    <>
      <div className=" w-full   p-4 rounded  bg-blueButton flex flex-col  ">
        <div className=" w-full flex">
          <div className=" w-1/6 flex justify-center p-2 border-[1px] border-white rounded-lg items-center">
            <img src={paclageDetails.image} alt={paclageDetails.title} />
          </div>
          <div className=" w-5/6 grid grid-cols-4 gap-y-5 p-2 place-items-center">
            <div className=" w-full flex flex-col justify-center items-center">
              <h3 className=" text-gray text-xl">Title</h3>
              <h4 className="text-white text-2xl">{paclageDetails.title}</h4>
            </div>
            <div className=" w-full flex flex-col justify-center items-center">
              <h3 className=" text-gray text-xl">Quantity</h3>
              <h4 className="text-white text-2xl">{paclageDetails.count}</h4>
            </div>
            <div className=" w-full flex flex-col justify-center items-center">
              <h3 className=" text-gray text-xl">Max Number to Buy</h3>
              <h4 className="text-white text-2xl">
                {paclageDetails.max_number_to_buy_at_once}
              </h4>
            </div>
            <div className=" w-full flex flex-col justify-center items-center">
              <h3 className=" text-gray text-xl">Card</h3>
              <Link
                target="blank"
                to={`/cards/card/${paclageDetails.card_id}?name=${cardNmae}`}
                className="text-white text-2xl hover:underline"
              >
                {cardNmae}
              </Link>
            </div>
            <div className=" w-full flex flex-col justify-center items-center">
              <h3 className=" text-gray text-xl">Normal User Price</h3>
              {paclageDetails.price_client_offers ? (
                <>
                  <h4 className="text-white text-xl line-through">
                    {parseFloat(paclageDetails.price_client).toFixed(2)}$
                  </h4>
                  <h4 className="text-white text-xl">
                    {parseFloat(paclageDetails.price_client_offers).toFixed(2)}$
                  </h4>
                </>
              ) : (
                <h4 className="text-white text-2xl">
                  {parseFloat(paclageDetails.price_client).toFixed(2)}$
                </h4>
              )}
            </div>
            <div className=" w-full flex flex-col justify-center items-center">
              <h3 className=" text-gray text-xl">Pos User Price</h3>
              {paclageDetails.price_pos_offers ? (
                <>
                  <h4 className="text-white text-xl line-through">
                    {parseFloat(paclageDetails.price_pos_client).toFixed(2)}$
                  </h4>
                  <h4 className="text-white text-xl">
                    {parseFloat(paclageDetails.price_pos_offers).toFixed(2)}$
                  </h4>
                </>
              ) : (
                <h4 className="text-white text-2xl">
                  {parseFloat(paclageDetails.price_pos_client).toFixed(2)}$
                </h4>
              )}
            </div>

            <div className=" w-full flex flex-col justify-center items-center">
              <h3 className=" text-gray text-xl">Is Active</h3>
              <h4 className="text-white text-2xl">
                {paclageDetails.is_active ? 'Yes' : 'No'}
              </h4>
            </div>

            <div className=" w-full flex flex-col justify-center items-center">
              <h3 className=" text-gray text-xl">In Stock</h3>
              <h4 className="text-white text-2xl">
                {paclageDetails.out_of_stock ? 'No' : 'Yes'}
              </h4>
            </div>
          </div>
        </div>

        <div className=" w-full flex justify-end">
          <button
            className=" border-[1px] border-white rounded py-1 px-5 text-white hover:scale-110 duration-300 hover:bg-white hover:text-blueButton "
            onClick={() => setEdit(true)}
          >
            Edit
          </button>
        </div>
      </div>
      <AnimatePresence>
        {edit && (
          <EditPackage
            updatePackage={updatePackage}
            close={() => setEdit(false)}
            pack={paclageDetails}
          />
        )}
      </AnimatePresence>
    </>
  )
}

export default PackageDetailes
